export const EnvProd = {
    api: 'https://us-central1-booking-car-mu.cloudfunctions.net/api',
    firebase: {
        bucket: 'https://storage.googleapis.com/booking-car-mu'
    }
}